// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_f934c381","isLeft":"_ab12ad19"};